import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  //@import url('https://fonts.googleapis.com/css?family=Jura:300,400,500,600,700');

  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: Jura, sans-serif;
    font-weight: 300;
  }
  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
    overflow-y: hidden;
  }
  * {
    font-family: Jura, sans-serif !important;

    // Disable the blue box when tapping a button in chrome on android.
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);
  }
`;

export default GlobalStyle;
